import React, { Component } from 'react';
import { serverIp, firebaseAuth, toCurrency, firebaseStorage, logComponentLoad } from '../../../../config/constants.js'
import { Form, Segment, Button } from 'semantic-ui-react';
import * as UiConsts from '../../../../config/UiConstants';
import axios from 'axios';
import { SingleDatePicker } from 'react-dates';
//import { getPrintValues, getDesigners, checkAdminEmail } from '../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Divider, Card, Icon, List } from 'semantic-ui-react';
import FileUploader from 'react-firebase-file-uploader';


import { } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import ViewRequisition_dynamic from '../Requisition/ViewRequisition_dynamic.js';

class PbAccountAccessLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            amountNeeded: null,
            newBalance: null,
            reason: '',
            pb_account_pass: '',
            unpaid_req: 0,
            dropdownItems: [],
            reqSelected: false,
            req: {},
            reqConfirmed: false,
            idpbAccAccessLog: '',
            openPbAccountReasonOptions: [],
            openPbAccountReason: '',
            reasonSelected: false,
            reqSelected: false,
            docUrl: '',
            recUploaded: false
        }
    }


    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {


                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }


    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "PbAccountAccessLog");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        });

        this.getUnPaidReqs();
        getPrintValues("openPbAccountReason", this.loadStatuses);
    }

    loadStatuses = (statuses) => {
        //  console.log("ddx12 ++++++ loadStatuses ");
        // console.log("ddx121 statuses:" + JSON.stringify(statuses, null, 3));
        this.setState({ openPbAccountReasonOptions: statuses })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    getUnPaidReqs = () => {
        console.log("entx1 +++++ getUnPaidReqs - ");
        axios.post(serverIp + 'billing/getUnpaidReqs', {
            apiKey: this.state.user.uid,
            enteredBy: this.state.user.email
        })
            .then((response) => {
                console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                console.log("entx22 result:" + response.data.result);

                // CHECK RECEIPTS
                if (response.data.result && response.data.dropdownItems) {

                    this.setState({
                        loading: false,
                        dropdownItems: response.data.dropdownItems
                    });
                    // alert("password retrieved:"); 

                    // CHECK ORDER NUMBER
                } else if (!response.data.result) {
                    alert("Error:" + response.data.message);
                    this.setState({ loading: false });
                }

                this.clearFields();

            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
                this.clearFields();
            });
    }

    // ##########################::  FIRST :##########################:
    send_pb_account_acess_log = () => {

        let tempAmountNeeded = null;
        let tempReasonNeeded = null;

        if (this.state.req && this.state.reqSelected) {

            tempAmountNeeded = this.state.req.rate;
            console.log("res is true: this.state.req.rate:" + tempAmountNeeded);

            tempReasonNeeded = this.state.req.label;
            console.log("tempReasonNeeded::" + tempReasonNeeded);

        } else {
            tempAmountNeeded = this.state.amountNeeded;
            console.log("NOT A REQ:" + tempAmountNeeded);

            tempReasonNeeded = this.state.reason;
            console.log("tempReasonNeeded::" + tempReasonNeeded);
        }

        if (tempAmountNeeded == 0 || tempAmountNeeded == null) {
            console.log("amount needed is empty");
            alert("Pls enter Amount needed")
        } else if (tempReasonNeeded == '' || tempReasonNeeded == null) {
            console.log("reason needed is empty")
            alert("Pls enter Reason needed")
        } else {

            this.setState({ loading: true });
            console.log("send_pb_account_acess_log");

            // SEND CHECK TO SERVER
            axios.post(serverIp + 'miscEndpoints/pb_account_acess_log', {
                apiKey: this.state.user.uid,
                //amountNeeded: this.state.req.rate,
                amountNeeded: tempAmountNeeded,
                //reason: this.state.req.label,
                reason: tempReasonNeeded,
                enteredBy: this.state.user.email,
                reqId: parseInt(this.state.req.key),
                openPbAccountReason: this.state.openPbAccountReason
            })
                .then((response) => {
                    console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result && response.data.pb_account_pass && response.data.pbAccAccessLog) {

                        this.setState({
                            loading: false,
                            pb_account_pass: response.data.pb_account_pass,
                            idpbAccAccessLog: response.data.pbAccAccessLog.idpbAccAccessLog
                        });
                        alert("password retrieved:");

                        // CHECK ORDER NUMBER
                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }

                    //this.clearFields();

                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ loading: false })
                    this.clearFields();
                });

        }




    }

    clearFields = () => {

        

        this.setState({
            loading: false,
            amountNeeded: 0,
            reason: '',
            reasonSelected: false,
            reqSelected: false,
            openPbAccountReason: null,
            docUrl: '',
            recUploaded: false,
            pb_account_pass:''
        })
    }

    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        //console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;

        if (value.category && value.category == "openPbAccountReason") {
            // value.category && value.category == "unpaid_req"

            if (value.value == 'requisition') {
                newState['reasonSelected'] = true;
                console.log("value.value == 'requisition', 'reasonSelected'] = true");
            }
            // else if (value.value == 'allowances'
            //     || value.value == 'stock_items_payment'
            //     || value.value == 'fabric_payment') {
            //     //newState['reasonSelected'] = true;
            //     newState['reqConfirmed'] = true;
            //     console.log("value.value == 'requisition', 'reasonSelected'] = true");
            // } 
            else {
                newState['reqConfirmed'] = true;
                console.log("value.value == 'requisition', 'reasonSelected'] = true");
            }

            //newState['req'] = value;

        } else if (value.category && value.category == "unpaid_req") {
            // value.category && value.category == "unpaid_req"
            newState['reqSelected'] = true;
            newState['req'] = value;
        }

        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    confirmReqFunc = () => {
        console.log("+++++ confirmReqFunc - ");

        this.setState({
            reqConfirmed: true
        })
    }

    /**
    * HANDLE THE FILE UPLOADING..
    */
    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }


    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({
                    docUrl: url,
                    //  recUploaded: true
                })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }

    uploadBankRec = () => {
        console.log("docx16 +++++++: uploadBankRec");

        if (this.state.docUrl == '') {

            alert("Pls upload doc");

        } else {
            axios.post(serverIp + 'miscEndpoints/uploadBankRec', {
                apiKey: this.state.user.uid,
                // newBalance: this.state.newBalance,
                imageUrl: this.state.docUrl,
                enteredBy: this.state.user.email,
                reqId: parseInt(this.state.req.key),
                idpbAccAccessLog: this.state.idpbAccAccessLog
            })
                .then((response) => {
                    console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                    console.log("entx22 result:" + response.data.result);

                    // CHECK RECEIPTS
                    if (response.data.result) {

                        this.setState({
                            loading: false,
                            recUploaded: true
                        });
                        alert("Reciept uploaded Complete");

                        this.clearFields();

                        // CHECK ORDER NUMBER
                    } else if (!response.data.result) {
                        alert("Error:" + response.data.message);
                        this.setState({ loading: false });
                    }

                    // 

                })
                .catch((error) => {
                    console.log(error);
                    //this.setState({ loading: false })
                    this.clearFields();
                });
        }

        this.setState({
            loading: true,
        });

        // SEND CHECK TO SERVER

    }

    skipRec = () => {
        console.log("+++++++: skipRec");

        this.setState({
            recUploaded: true
        })
    }

    render() {

        const reqCard = this.state.reqSelected
            ? <div>
                <Divider horizontal>{'Confirm Requisition'}</Divider>
                <Card>
                    <Card.Content header={this.state.req.label} />
                    <Card.Content description={"Amount:" + toCurrency(this.state.req.rate)} />
                    <Card.Content description={"Reqstd by:" + this.state.req.reqBy} />
                    <Card.Content description={"Send To:" + this.state.req.sendTo} />
                    <Card.Content extra>
                        <Icon name='user' />{this.state.req.dateReq}
                    </Card.Content>
                </Card>
            </div>
            : ''

        const confirmReq = this.state.reqSelected
            ? <Button fluid color='red' onClick={this.confirmReqFunc}> Confirm Req</Button>
            : ""

        const reqs = this.state.reasonSelected && this.state.dropdownItems.length > 0
            ? <div>
                <Divider horizontal>{'Select Requisition'}</Divider>
                <Select
                    name="form-field-name"
                    value={this.state.unpaid_req}
                    options={this.state.dropdownItems}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />
            </div>
            : ''



        const reasonUi = this.state.openPbAccountReasonOptions.length > 0
            ? <div>
                <Divider horizontal>{'Select Reason'}</Divider>
                <Select
                    name="form-field-name"
                    value={this.state.openPbAccountReason}
                    options={this.state.openPbAccountReasonOptions}
                    onChange={this.handleDropDownChanges}
                    searchable={true}
                    clearable={false}
                />
            </div>
            : ''


        const passUi = this.state.pb_account_pass != ''
            ? <div>
                <Divider horizontal>{'Step: Press this button to copy password'}</Divider>
                <CopyToClipboard text={this.state.pb_account_pass}
                    onCopy={() => this.setState({ copied: true })}>
                    <Button fluid color='brown'>COPY PASS</Button>
                </CopyToClipboard>
                <br />

            </div>
            : ''

        const bankInstructions = this.state.pb_account_pass != ''
            ? <div>
                <Divider horizontal>{'Step: Follow Instructions to login and make Payment'}</Divider>
                <List ordered>
                    <List.Item><a href={'https://ibanking.stanbicbank.co.ug/#/login'} target="_blank">Click this link to visit stanbic site</a></List.Item>
                    <List.Item >Enter Username: XXXXXX (provided to you separately)</List.Item>
                    <List.Item >Right Click Password Feild and and paste</List.Item>
                    <List.Item >Login and make the payment</List.Item>
                    <List.Item >Come back to the page and upload receipt and latest balance</List.Item>
                </List>
            </div>
            : ''

        const formUi = this.state.reqConfirmed
            ? <div>
                <Divider horizontal>{'STEP: REQUEST ACCESS'}</Divider>
                <Form size='large' onSubmit={this.send_pb_account_acess_log}>
                    <label>Amount Needed: {toCurrency(this.state.amountNeeded)} </label>
                    <Form.Input
                        fluid
                        name={'amountNeeded'}
                        value={this.state.amountNeeded}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Amount Needed'
                        onChange={this.handleTextInputChange}
                        type='number'
                    />

                    <Form.Input
                        fluid
                        name={'reason'}
                        value={this.state.reason}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Reason Needed'
                        onChange={this.handleTextInputChange}
                        type='text'
                    />
                    <Button color='blue' fluid size='large'>REQ PASS</Button>
                </Form>
            </div>
            : ''

        const fileUploadUI = this.state.pb_account_pass != ''
            ? <div>
                <h4>UPLOAD STANBIC RECEIPT: {this.state.docUrl}</h4>
                <FileUploader
                    accept="*,"
                    name="avatar"
                    filename={this.props.fileName}
                    //storageRef={firebaseStorage.ref('orderDesigns/')}
                    storageRef={firebaseStorage.ref('printbdocs')}
                    onUploadStart={this.handleUploadStart}
                    onUploadSuccess={this.handleUploadSuccess}
                    onProgress={this.handleProgress}
                />
            </div>
            : ''

        const confirmPayment = this.state.pb_account_pass != ''
            ? <div>
                <Divider horizontal>{'Step: Upload Stanbic Receipt'}</Divider>

                {fileUploadUI}

                <Button color='blue' fluid size='large' onClick={this.uploadBankRec}>UPLOAD REC</Button>

                <br />
                <Button color='red' fluid size='large' onClick={this.skipRec} >SKIP</Button>


                {/* <Form size='large' onSubmit={this.completePayment}> */}

                {/* PRICE */}
                {/* <Form.Field>
                        <label>newBalance: {toCurrency(this.state.newBalance)} </label>
                        <Form.Input
                            fluid
                            name={'newBalance'}
                            value={this.state.newBalance}
                            icon='add user'
                            iconPosition='left'
                            placeholder='Price'
                            onChange={this.handleTextInputChange}
                            type='number'
                        />
                    </Form.Field> */}

                {/* {fileUploadUI} */}

                {/* <Button color='blue' fluid size='large'>COMPLETE PAYMENT</Button> */}

                {/* <Button color='blue' fluid size='large'>UPLOAD REC</Button>
                </Form> */}
            </div>
            : ''

        const payReqUi = this.state.pb_account_pass != '' && this.state.docUrl != '' && this.state.recUploaded
            //const payReqUi = this.state.reqSelected && this.state.req && this.state.pb_account_pass != ''
            ? <ViewRequisition_dynamic
                algoliaUser={this.state.algoliaUser}
                reqId={this.state.req.key}
                user={this.state.user}
                clearFields={this.clearFields}
            />
            : ''

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.perms.includes("pb_account_acc")
            ? <div>

                {/* STEP 1 */}
                {reasonUi}

                {reqs}
                <br />

                {reqCard}
                <br />
                {confirmReq}

                {formUi}

                {passUi}

                {bankInstructions}

                {confirmPayment}

                {payReqUi}

            </div>
            : <h2>YOU ARE NOT AN AUTHORIZED</h2>


        return (
            this.state.loading ? <UiConsts.LoadingComponent /> :
                <div>
                    <h1>REQUEST PB ACC PASSWRD</h1>
                    {wholeUI}
                </div>
        );
    }
}

export default PbAccountAccessLog;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/PbAccountAccess/PbAccountAccessLog.js